import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';

import { of } from 'rxjs/observable/of';
import type { Observable } from 'rxjs/Observable';
import { loadUserPropertyKeysService } from '../../../services/whiteboards-entrypoint-experiment/index.tsx';
import { LOAD_APP_DATA_REQUEST } from '../../../state/actions/app/index.tsx';
import {
	setUserPropertyKeys,
	type SetUserPropertyKeysAction,
} from '../../../state/actions/whiteboards-entrypoint-experiment/index.tsx';
import { getAtlassianAccountId } from '../../../state/selectors/app/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../../state/types.tsx';

export const loadUserPropertyKeysEpic = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
): Observable<SetUserPropertyKeysAction> =>
	action$
		.ofType(LOAD_APP_DATA_REQUEST)
		// Prevents multiple requests from being fired off
		.debounceTime(300)
		.switchMap(() => {
			const accountId = getAtlassianAccountId(store.getState());
			if (accountId) {
				return loadUserPropertyKeysService(accountId).map(setUserPropertyKeys);
			}
			return of();
		});
